import { ReactElement } from 'react';
import { Box, Alert } from '@mui/material';

export const ScalingConfigAlert = (): ReactElement => (
  <Box mb={1}>
    <Alert severity="warning">
      Please publish the function or select published version to view/modify scaling config
    </Alert>
  </Box>
);
